import * as actionTypes from './actions';
import initialState from './initialState';

export default function sentToGp3Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SIGN_SERVER_REQUEST_START:
    case actionTypes.SIGN_CLIENT_REQUEST_START: {
      return { ...state, error: false, loading: true };
    }
    case actionTypes.SIGN_REQUEST_SUCCESS:
      return { data: 'OK', error: false, loading: false };
    case actionTypes.SIGN_REQUEST_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case actionTypes.CLEAR_SIGN_DATA:
      return { ...initialState };
    default:
      return state;
  }
}
